export const useScrollMotion = () => {
  const isFooterVisible = ref(false);
  const scrollY = ref(0);
  const scroll = 100;

  const handleScroll = () => {
    const currentScrollY = window.scrollY;
    if (currentScrollY < scroll) {
      isFooterVisible.value = false;
    } else {
      isFooterVisible.value = true;
    }
    scrollY.value = currentScrollY;
  };

  return { handleScroll, isFooterVisible };
};
